<template>
    <div>
        <el-tabs v-model="activeName" stretch @tab-click="handleClick">
            <el-tab-pane v-for="(item,index) in list" :key="index" :label="item.lable" :name="item.name">
                <div v-for="(ITEM,INDEX) in item.arr" :key="INDEX" class="item" @click="detailEvent(ITEM,item)">
                    <div class="left">
                        <div>{{ ITEM.xName }}</div>
                        <div>中国移动通信联合会 | {{ ITEM.showTime }}</div>
                    </div>
                    <div class="right">
                        <img :src="ITEM.imageFace" alt="">
                    </div>
                </div>
            </el-tab-pane>
        </el-tabs>
    </div>
</template>

<script>
export default {
    data() {
        return {
            activeName: 'first',
            list: [
                {lable: '新闻中心', name: 'first', cId: 1},
                {lable: '政策法规', name: 'second', cId: 4},
                {lable: '会议活动', name: 'third', cId: 5}
            ]
        }
    },
    mounted() {
        this.getTab(1)
    },
    methods: {
        handleClick() {
            let index = ''
            for (let i = 0;i < this.list.length;i++) {
                if (this.list[i].name == this.activeName) {
                    index = this.list[i].cId
                    this.getTab(index)
                }
            }

        },
        getTab(i) {
            this.list.map((item, index) => {
                if (item.name == this.activeName) {
                    this.$api.get(`news/xList?cId=${i}&limit=4&offset=0`).then(res => {
                        if (res.data.list.length > 0) {
                            this.$set(this.list[index], 'arr', res.data.list)
                        } else {
                            this.$set(this.list[index], 'arr', [])
                        }
                    })
                }

            })
            console.log(this.list)

        },
        detailEvent(ITEM, item) {
            console.log(item)
            console.log(ITEM)
            this.$router.push({
                name: 'PoliciesDetails',
                params: {
                    xId: ITEM.xId
                }
            })

        }
    }
}
</script>

<style lang="scss" scoped>
//scss
.item {
    display: flex;
    justify-content: space-between;
    align-items: center;
    margin: 0 15.6px;
    padding: 20.8px 0;
    border-bottom: 1px solid rgba(12, 25, 41, 0.08);
    .left {
        flex: 1;
        height: 83.72px;
        display: flex;
        flex-direction: column;
        justify-content: space-between;
        div:nth-child(1) {
            font-size: 15.6px;
            font-weight: 400;
            text-align: left;
            color: #1a1b1f;
            overflow: hidden;
            text-overflow: ellipsis;
            display: -webkit-box;
            -webkit-line-clamp: 2;
            -webkit-box-orient: vertical;
        }
        div:nth-child(2) {
            font-size: 11.44px;
            font-weight: 400;
            text-align: left;
            color: #999;
        }
    }
    .right {
        width: 113.88px;
        height: 83.72px;
        margin-left: 10.4px;
        img {
            width: 100%;
            height: 100%;
        }
    }
}
::v-deep .el-tabs__header {
    margin: 0;
}
::v-deep .el-tabs__nav-wrap::after {
    background: none;
}
::v-deep .el-tabs__nav {
    background: #f7f8fa;
    padding-top: 13px;
    padding-bottom: 5px;
}
::v-deep .el-tabs__item {
    font-size: 17px;
    font-weight: 700;
}
::v-deep .el-tabs__item.is-active {
    color: #243db3;
}
::v-deep .el-tabs__active-bar {
    //     width: 26.52px !important;
    //     height: 2.08px;
    background: #3858e6;
    //     left: calc(16% - 13.3px);
}
</style>
